export enum ServiceTypeIconSize {
    small = 'small',
    big = 'big',
}
